'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _uikit = require('uikit');

var _uikit2 = _interopRequireDefault(_uikit);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavBar = function (_React$Component) {
  _inherits(NavBar, _React$Component);

  function NavBar() {
    _classCallCheck(this, NavBar);

    return _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).apply(this, arguments));
  }

  _createClass(NavBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.slidenav) {
        var slidenavLeft = _reactDom2.default.findDOMNode(this.slidenavLeft);
        slidenavLeft.setAttribute('uk-slidenav-previous', '');
        slidenavLeft.setAttribute('uk-slideshow-item', 'previous');
        var slidenavRight = _reactDom2.default.findDOMNode(this.slidenavRight);
        slidenavRight.setAttribute('uk-slidenav-next', '');
        slidenavRight.setAttribute('uk-slideshow-item', 'next');
      }

      this.UIkitComponent = _uikit2.default.slideshow((0, _jquery2.default)(this.gridElement), {
        animation: this.props.animation,
        autoplay: this.props.autoplay,
        autoplayInterval: this.props.autoplayInterval,
        finite: this.props.finite,
        pauseOnHover: this.props.pauseOnHover,
        index: this.props.index,
        velocity: this.props.velocity,
        ratio: this.props.ratio,
        minHeight: this.props.minHeight,
        maxHeight: this.props.maxHeight
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.UIkitComponent.$emit(event = 'update');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.UIkitComponent.$destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          className: this.props.className,
          ref: function ref(element) {
            _this2.gridElement = element;
          }
        },
        this.props.slidenav ? _react2.default.createElement(
          'div',
          { className: 'uk-position-relative uk-visible-toggle uk-light' },
          this.props.children,
          _react2.default.createElement('a', { ref: function ref(element) {
              _this2.slidenavLeft = element;
            }, className: 'uk-position-center-left uk-position-small uk-hidden-hover', href: '#' }),
          _react2.default.createElement('a', { ref: function ref(element) {
              _this2.slidenavRight = element;
            }, className: 'uk-position-center-right uk-position-small uk-hidden-hover', href: '#' })
        ) : _react2.default.createElement(
          'div',
          null,
          this.props.children
        )
      );
    }
  }]);

  return NavBar;
}(_react2.default.Component);

exports.default = NavBar;